// Helper function to convert timestamp to time string
export const formatTime = (startTimestamp, endTimestamp) => {
  const startDate = new Date(startTimestamp * 1000);
  const endDate = new Date(endTimestamp * 1000);

  const formatTimeStr = (date) => {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const minutesStr = minutes < 10 ? `0${minutes}` : minutes;
    return `${hours}:${minutesStr} ${ampm}`;
  };

  return `${formatTimeStr(startDate)} - ${formatTimeStr(endDate)}`;
};

// Helper function to calculate time until appointment
export const getTimeUntilAppointment = (startTimestamp) => {
  const now = Math.floor(Date.now() / 1000);
  const diffSeconds = startTimestamp - now;

  if (diffSeconds < 0) return null; // Already started

  const diffMinutes = Math.floor(diffSeconds / 60);

  if (diffMinutes < 60) {
    return `Starting in ${diffMinutes} minutes`;
  } else if (diffMinutes < 1440) {
    // Less than 24 hours
    const hours = Math.floor(diffMinutes / 60);
    return `Starting in ${hours} hour${hours > 1 ? "s" : ""}`;
  } else {
    const days = Math.floor(diffMinutes / 1440);
    return `Starting in ${days} day${days > 1 ? "s" : ""}`;
  }
};
